import {CustomText, PSmallText} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Cross} from '@buncha/components/core/icon';
import {HBox} from '@buncha/components/core/view';
import React from 'react';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {styles} from './styles';

interface FailedItemCellFooterProps {
  title: string;
  subTitle: string;
}

const FailedItemCellFooter: React.FC<FailedItemCellFooterProps> = props => {
  const {title, subTitle} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  return (
    <HBox
      style={[
        styles.container,
        {
          borderColor: theme?.text.red[100],
        },
      ]}>
      <HBox style={styles.subContainer}>
        <Cross
          width={scaleFonts(15)}
          height={scaleFonts(15)}
          viewBox="0 0 15 15"
          fill={theme?.text.red[100]}
        />
        <CustomText
          style={[
            styles.textAlign,
            styles.titleStyle,
            {
              fontFamily: muliFont[900].normal,
              color: theme?.text.red[100],
            },
          ]}>
          {title}
        </CustomText>
      </HBox>
      <PSmallText
        style={[
          styles.textAlign,
          {fontFamily: muliFont[600].normal, color: theme?.text.blue[300]},
        ]}>
        {subTitle}
      </PSmallText>
    </HBox>
  );
};
export default React.memo(FailedItemCellFooter);
